import { queryData } from './queryService';
import { gamesQuery } from '../queries/userQueries';

export const getGames = async () => {
  const graphData = await queryData(gamesQuery);
  return graphData.data.games.sort(
    (a, b) => b.priceCheckStartTime - a.priceCheckStartTime
  );
};
